<template>
	<div class="content">
		<headerTop></headerTop>
		<div class="swiperImg" :style="{backgroundImage:'url('+$index.addurl(img)+')'}"></div>
		<!-- 服务体系 -->
		<div class="center page-content flexbetween" :style="{animation:animation}">
			<div class="left">
				<div class="leftD">
					<div class="leftD_child" v-for="(item,index) in techList" @click="todetail(item.id)">{{item.title}}</div>
				</div>
			</div>
			<div class="right">
				<div class="child" v-html="contents"> </div>
			</div>
		</div>
	</div>
</template>

<script>
	import router from "../../router";
	import headerTop from '../../components/headerTop.vue'
	export default{
		components: {
			headerTop
		},
		data(){
			return {
				img:'',
				contents:'',
				animation:'',
				techList:[],
			}
		},
		created() {
			this.animation = 'detail .4s linear forwards'
			this.getdata();
			this.getqylist();
		},
		methods:{
			todetail(id){
				if(id == 1){
					this.$router.push({name:'fwTixi',query:{id:id}})
				}else if(id == 2){
					this.$router.push({name:'cxPingtai',query:{id:id}})
				}else if(id == 3){
					this.$router.push({name:'jrfuCs',query:{id:id}})
				}else if(id == 4){
					this.$router.push({name:'fwAnlis',query:{id:id}})
				}
			},
			getqylist(){
				let _this = this;
				_this.$api.user.enterpriseServicesList().then(res => {
					if(res.code == 1){
						_this.techList = res.data;
					}
				})
			},
			getdata(){
				let id = this.$route.query.id;
				let _this = this;
				_this.$api.user.enterpriseServicesDetails({
					id,
				}).then(res => {
					if(res.code == 1){
						_this.contents = res.data.content;
						_this.img = res.data.background_img;
					}
				})
			},
		},
		
	}
</script>
<style scoped>
	.content{
		background-color: #1452DC;
		border-bottom: 1px solid #1452DC;
	}
</style>
<style scoped lang="scss">
	.left{
		align-self: flex-start;
		position: sticky;
		top: 100px;
		.leftD{
			background-color: #fff;
			border-radius: 20px;
			padding: 14px 20px 6px;
			width: 8vw;
			align-self: flex-start;
			z-index: 100;
			background-color: rgba(207, 232, 252, 0.5);
			margin-right: 20px;
			.leftD_child{
				margin: 20px 0;
				padding-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #333;
				border-bottom: 1px solid #fff;
			}
			.leftD_child:last-child{
				border: none;
			}
			.leftD_child:hover{
				cursor: pointer;
				color: #1452DC;
				animation: changeTab .2s linear forwards;
			}
		}
	}
	.right{
		flex-grow: 1;
	}
	.swiperImg{
		max-width: 1920px;
		background-image: url('../../assets/page4/bg1.png');
		background-size: cover;
		background-position: center;
		position: relative;
		padding: 220px 0;
		.lTitle{
			margin-left: 4vw;
			font-size: 30px;
			letter-spacing: 4px;
			color: #fff;
		}
		.bTitle{
			margin-left: 4vw;
			color: #fff;
			font-size: 58px;
			letter-spacing: 4px;
			font-weight: bold;
		}
		.sTitle{
			margin-left: 4vw;
			letter-spacing: 2px;
			font-size: 14px;
			color: #fff;
		}
	}
	.center{
		min-height: 300px;
		margin: 0 auto 100px;
		background-color: #fff;
		// padding: 70px 190px;
		padding: 80px 120px 60px 60px;
		border-radius: 30px;
		position: relative;
		top: -80px;
		.child{
			.img{
				width: 45%;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.txt{
				width: 45%;
				
			}
		}
	}
</style>


// WEBPACK FOOTER //
// fwTixi.vue?f6788780